export type BrowserTranslator = {
  translate: (text: string) => Promise<string>;
  destroy: () => void;
};
export type TranslatorAPI = {
  create: (options: {
    sourceLanguage: string;
    targetLanguage: string;
    monitor: (monitor: {
      addEventListener: (
        name: "downloadprogress",
        listener: (event: { loaded: number }) => void,
      ) => void;
    }) => void;
  }) => Promise<BrowserTranslator>;
};

/** Shared browser-only English to Chinese translation, without a remote fallback. */
export async function createBrowserTranslator(onProgress: (loaded: number) => void = () => {}) {
  const api = (window as unknown as { Translator?: TranslatorAPI }).Translator;
  if (!api) throw new Error("当前浏览器不支持内置翻译，已保留英文结果。");
  return api.create({
    sourceLanguage: "en",
    targetLanguage: "zh",
    monitor: (monitor) => monitor.addEventListener("downloadprogress", (event) => onProgress(event.loaded)),
  });
}
